import { News } from "types/News"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const toPublishReducer: RemoteReducer<News[]> =
  createRemoteReducer("toPublish")
